<template>
    <label
        class="ui-switch"
        :class="{
            'ui-switch--checked': isChecked,
            'ui-switch--disabled': disabled,
        }"
    >
        <input
            class="ui-switch__input"
            type="checkbox"
            :checked="isChecked"
            :disabled="disabled"
            @change="onChange"
        />
        <span class="ui-switch__track" aria-hidden="true">
            <span class="ui-switch__thumb"></span>
        </span>
        <span v-if="label" class="ui-switch__label">{{ label }}</span>
    </label>
</template>

<script>
export default {
    name: "SwitchComponent",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isChecked() {
            return this.value;
        },
    },
    methods: {
        onChange(event) {
            const checked = event.target.checked;
            this.$emit("input", checked);
            this.$emit("change", checked);
        },
    },
};
</script>

<style scoped lang="scss">
.ui-switch {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;
}

.ui-switch--disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.ui-switch__input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.ui-switch__track {
    width: 46px;
    height: 28px;
    border-radius: 999px;
    background: #d6dbe3;
    padding: 3px;
    transition:
        background-color 0.2s ease,
        box-shadow 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.06);
}

.ui-switch__thumb {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow:
        0 1px 2px rgba(15, 23, 42, 0.14),
        0 3px 8px rgba(15, 23, 42, 0.14);
    transform: translateX(0);
    transition: transform 0.2s ease;
}

.ui-switch--checked .ui-switch__track {
    background: #34c759;
}

.ui-switch--checked .ui-switch__thumb {
    transform: translateX(18px);
}

.ui-switch__label {
    font-size: 14px;
    font-weight: 600;
    color: #4b5563;
    white-space: nowrap;
}
</style>
